import React from 'react';

interface StepperProps {
  steps: string[];
  currentStep: number;
}

const PURPLE = '#6C3EB8';
const PURPLE_LIGHT = '#E5D8F6';
const GRAY = '#bbb';

const BALL_SIZE = 20;
const LABEL_FONT_SIZE = 13;
const STEP_MIN_WIDTH = 48;
const LINE_MIN_WIDTH = 8;

const Stepper: React.FC<StepperProps> = ({ steps, currentStep }) => {
  return (
    <div style={{ width: '100%', margin: '16px 0 12px 0', display: 'flex', justifyContent: 'space-between' }}>
      {steps.map((label, idx) => {
        const isCompleted = idx + 1 < currentStep;
        const isCurrent = idx + 1 === currentStep;
        const showLeftLine = idx !== 0;
        const showRightLine = idx !== steps.length - 1;
        return (
          <div
            key={label}
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              position: 'relative',
              minWidth: STEP_MIN_WIDTH,
            }}
          >
            {/* Label */}
            <div
              style={{
                textAlign: 'center',
                fontSize: LABEL_FONT_SIZE,
                color: isCurrent ? '#000' : GRAY,
                fontWeight: isCurrent ? 600 : 400,
                marginBottom: 4,
                minHeight: 16,
                lineHeight: 1.1,
                whiteSpace: 'nowrap',
                maxWidth: 70,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {label}
            </div>
            {/* Line + Ball Row */}
            <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
              {showLeftLine && (
                <div
                  style={{
                    flex: 1,
                    height: 3,
                    background: idx < currentStep ? PURPLE : PURPLE_LIGHT,
                    borderRadius: 2,
                    minWidth: LINE_MIN_WIDTH,
                  }}
                />
              )}
              <div
                style={{
                  width: BALL_SIZE,
                  height: BALL_SIZE,
                  borderRadius: '50%',
                  background: isCompleted ? PURPLE : isCurrent ? '#fff' : GRAY,
                  border: `2px solid ${isCompleted ? PURPLE : isCurrent ? PURPLE : GRAY}`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 1,
                  transition: 'background 0.2s, border 0.2s',
                }}
              >
                {isCompleted ? (
                  <svg width="12" height="12" viewBox="0 0 16 16" fill="none">
                    <path
                      d="M4 8.5L7 11.5L12 5.5"
                      stroke="#fff"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                ) : null}
              </div>
              {showRightLine && (
                <div
                  style={{
                    flex: 1,
                    height: 3,
                    background: idx + 1 < currentStep ? PURPLE : PURPLE_LIGHT,
                    borderRadius: 2,
                    minWidth: LINE_MIN_WIDTH,
                  }}
                />
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Stepper;
